import { render, staticRenderFns } from "./ChatProductMention.vue?vue&type=template&id=780a70a5&scoped=true&"
import script from "./ChatProductMention.vue?vue&type=script&lang=js&"
export * from "./ChatProductMention.vue?vue&type=script&lang=js&"
import style0 from "./ChatProductMention.vue?vue&type=style&index=0&id=780a70a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a70a5",
  null
  
)

export default component.exports